var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 107,
    viewBox: "0 0 261 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.894 2.73533L8.50913 72.7851C5.90302 74.4119 3.75464 76.6732 2.26608 79.3562C0.777516 82.0393 -0.00229299 85.0559 5.0645e-06 88.1224V245.89C-0.00230418 249.249 0.934714 252.542 2.70575 255.399C4.47678 258.257 7.01164 260.564 10.0254 262.064L122.41 318.093C124.925 319.347 127.697 320 130.509 320C133.32 320 136.093 319.347 138.608 318.093L250.992 262.064C254.002 260.56 256.532 258.251 258.299 255.394C260.067 252.538 261.002 249.247 261 245.89V88.1224C261.001 85.0562 260.22 82.0402 258.732 79.3575C257.243 76.6747 255.096 74.4131 252.491 72.7851L140.106 2.73533C137.223 0.947491 133.895 0 130.5 0C127.105 0 123.777 0.947491 120.894 2.73533ZM228.337 224.521L130.491 273.326L32.6272 224.521V187.922L130.491 126.91L228.337 187.922V224.521ZM228.337 139.116L130.491 78.1051L32.6272 139.116V106.573L130.491 45.5623L228.337 106.573V139.116Z",
    fill: "url(#paint0_linear_3211_9539)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3211_9539",
    x1: 130.5,
    y1: 1.25987e-7,
    x2: 135.683,
    y2: 335.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#461F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#431C70",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletArrow);
export default __webpack_public_path__ + "static/media/walletArrow.97fb9ecdf64e670ff06256b2051bc4dc.svg";
export { ForwardRef as ReactComponent };